import { useGetWorkflow } from "@/api/useWorkflow"
import { Link, Spin } from "@/atoms"
import { NAMES_ROUTES } from "@/const/routes.constants"

import type { Workflow } from "@/api/useWorkflow.types"
import type { TFunction } from "@/hooks/useTranslation"

// Workflow ids are 32 hex characters; legacy rows can carry an email or nothing here
const WORKFLOW_ID_PATTERN = /^[0-9a-f]{32}$/

export const DismissedByWorkflow = (props: {
  workflowId: string
  t: TFunction
}) => {
  const { workflowId, t } = props
  const { ROOT, WORKFLOWS } = NAMES_ROUTES.GOVERNANCE
  // A deleted workflow (404) or one the user can't view (403) gets the generic label: no toast, no log, no error page
  const { response, isLoading } = useGetWorkflow<KosmosApi.Response<Workflow>>(
    { needle: workflowId },
    {
      enabled: WORKFLOW_ID_PATTERN.test(workflowId),
      silentErrors: true,
      throwOnError: false,
      // A failed lookup won't succeed on the next label (e.g. "Show changes" or a popover hover)
      retryOnMount: false,
      preventLogStatuses: [403, 404]
    }
  )
  const name = response?.data?.name

  if (isLoading) return <Spin size="small" />

  // No workflow to open, so the generic label isn't a link
  if (!name) return t("automaticDismissedBy")

  return (
    <Link
      href={`/${ROOT}/${WORKFLOWS}/${workflowId}`}
      target="_blank"
      type="link"
    >
      {t("workflowBy", { name })}
    </Link>
  )
}
